<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card :key="fullKey">
      <b-card-body>
        <b-row>
          <b-col sm="4">
            <b-form-group>
              <label>Swiggy Metrics Upload</label>
              <a v-if="swiggyFile" :key="key" :href="cdn + '/' + swiggyFile">{{
                swiggyFile
              }}</a>
              <ChunkUpload
                :key="swiggyFile"
                @uploadcomplete="
                  (v) => {
                    swiggyFile = v;
                  }
                "
              ></ChunkUpload>
            </b-form-group>
          </b-col>

          <b-col sm="4">
            <b-form-group>
              <label>Zomato Metrics Upload</label>
              <a v-if="zomatoFile" :key="key" :href="cdn + '/' + zomatoFile">{{
                zomatoFile
              }}</a>
              <ChunkUpload
                :key="zomatoFile"
                @uploadcomplete="
                  (v) => {
                    zomatoFile = v;
                  }
                "
              ></ChunkUpload>
            </b-form-group>
          </b-col>

          <b-col sm="4">
            <b-form-group>
              <label>OOS Report Upload</label>
              <a v-if="oosFile" :key="key" :href="cdn + '/' + oosFile">{{
                oosFile
              }}</a>
              <ChunkUpload
                :key="oosFile"
                @uploadcomplete="
                  (v) => {
                    oosFile = v;
                  }
                "
              ></ChunkUpload>
            </b-form-group>
          </b-col>

          <b-col sm="4">
            <b-form-group>
              <label>Date Range</label>
              <date-picker
                range
                v-model="date_range"
                show-week-number
              ></date-picker>
            </b-form-group>
          </b-col>

          <b-col sm="4">
            <b-form-group>
              <label>Select Columns</label>
              <div>
                <b-badge
                  v-for="(columnKey, index) in selectedColumns"
                  :key="index"
                  variant="primary"
                  class="mr-1"
                >
                  {{ columns.filter((f) => f.key === columnKey)[0].value }}
                </b-badge>
              </div>
              <SelectWithSearch
                :multi_select="true"
                :search_without_api="true"
                :optionsData="columns"
                track_by="key"
                display="value"
                :selected_data="selectedColumns"
                :key="key"
                selected_by="key"
                @selectedOption="(v) => (selectedColumns = v)"
              ></SelectWithSearch>
            </b-form-group>
          </b-col>

          <b-col sm="4" style="align-self: flex-end">
            <b-form-group>
              <b-button variant="success" class="mt-2" @click="generateReport">
                Generate Report
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <div class="table-responsive">
      <b-table
        :key="reports.key"
        :items="reports.data"
        :fields="fields"
        responsive="sm"
        :per-page="reports.per_page"
        :current-page="currentPage"
      >
        <template v-slot:cell(payload)="row">
          <p>
            Start Date: {{ row.item.payload.start_date }} <br />
            End Date: {{ row.item.payload.end_date }}
          </p>
        </template>
        <template v-slot:cell(created_at)="row">
          <p>{{ moment(row.item.created_at).format("DD-MM-YYYY") }}</p>
        </template>
        <template v-slot:cell(actions)="row">
          <a
            class="btn btn-primary"
            :href="row.item.url"
            v-if="row.item.url"
            variant="success"
          >
            <i class="fa fa-download"></i>
          </a>
          <b-button
            class="ml-2"
            @click="recycle(row.item)"
            v-if="row.item.url"
            variant="success"
          >
            <i class="fa fa-recycle"></i>
          </b-button>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              :key="reports.key"
              v-model="currentPage"
              :total-rows="reports.total"
              :per-page="reports.per_page"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import DatePicker from "vue2-datepicker";
import SelectWithSearch from "../Common/SelectWithSearch.vue";
import ChunkUpload from "../utils/ChunkUpload.vue";
import { BUSSINESS_REPORT_PATH } from "@/path";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
export default {
  components: {
    Layout,
    PageHeader,
    DatePicker,
    SelectWithSearch,
    ChunkUpload,
  },
  data() {
    return {
      title: "Business Report Downloads",
      items: [{ text: "Business Report" }, { text: "Downloads", active: true }],
      columns: [
        { key: "1", value: "Online %" },
        { key: "2", value: "Impressions to" },
        { key: "3", value: "Ads impressions" },
        { key: "4", value: "Ads orders" },
        { key: "5", value: "Menu opens" },
        { key: "6", value: "Ads menu" },
        { key: "7", value: "Offline time" },
        { key: "8", value: "Lost sales" },
        { key: "9", value: "FOR accuracy" },
        { key: "10", value: "Effective discount" },
        { key: "11", value: "Average rating" },
        { key: "12", value: "Total complaints" },
        { key: "13", value: "Orders with" },
        { key: "14", value: "Poor rated" },
        { key: "15", value: "KPT+10 delayed" },
        { key: "16", value: "Lunch Orders" },
        { key: "17", value: "Cart builds" },
        { key: "18", value: "Discount given" },
        { key: "19", value: "Bad orders" },
        { key: "20", value: "Ads spend" },
        { key: "21", value: "Gross sales" },
        { key: "22", value: "Sales from" },
        { key: "23", value: "Lapsed user" },
        { key: "24", value: "Cart to" },
        { key: "25", value: "Customer refunded" },
        { key: "26", value: "Rejected orders" },
        { key: "27", value: "Rated orders" },
        { key: "28", value: "Late night" },
        { key: "29", value: "Sales (Rs)" },
        { key: "30", value: "New user" },
        { key: "31", value: "Market share" },
        { key: "32", value: "Ads ROI" },
        { key: "33", value: "Impressions" },
        { key: "34", value: "Average order" },
        { key: "35", value: "KPT (in" },
        { key: "36", value: "Ads CTR" },
        { key: "37", value: "Non-refunded complaints" },
        { key: "38", value: "Dinner Orders" },
        { key: "39", value: "Delivered orders" },
        { key: "40", value: "Placed Orders" },
        { key: "41", value: "Menu to" },
        { key: "42", value: "Repeat user" },
        { key: "43", value: "Snack Orders" },
        { key: "44", value: "Breakfast orders" },
      ],
      moment: moment,
      date_range: { startDate: new Date("2024-12-01"), endDate: "2024-12-10" },
      swiggyFile: null,
      zomatoFile: null,
      oosFile: null,
      selectedColumns: [],
      selectedReport: null,
      base_node_url: process.env.VUE_APP_API_BACKEND_URL,
      key: 1,
      cdn: process.env.VUE_APP_AWS_CDN,
      reports: [],
      currentPage: 1,
      fullKey: 1,
      fields: ["payload", "created_at", "status", "file", "actions"],
    };
  },
  mounted() {
    this.getReports();
  },
  computed() {
    console.log(this.date_range);
  },
  methods: {
    validateInputs() {
      if (!this.date_range || this.date_range.length !== 2) {
        alert("Please select a valid date range.");
        return false;
      }
      if (!this.zomatoFile || !this.swiggyFile || !this.oosFile) {
        alert("Please upload all required files.");
        return false;
      }
      if (!this.selectedColumns.length) {
        alert("Please select at least one column.");
        return false;
      }
      return true;
    },
    recycle(report) {
      this.selectedReport = report;
      report = report.payload;
      this.date_range = [
        new Date(report.start_date),
        new Date(report.end_date),
      ];
      this.swiggyFile = report.swiggy_file;
      this.zomatoFile = report.zomato_file;
      this.oosFile = report.menu_file;
      this.selectedColumns = report.columns;
      console.log(report.columns);
      console.log(this.selectedColumns);
      console.log(this.swiggyFile);
      this.key += 1;
    },
    async generateReport() {
      if (!this.validateInputs()) {
        return;
      }
      try {
        let res = await axios.post(
          this.base_node_url + BUSSINESS_REPORT_PATH.POST_OSS_REPORT,
          {
            start_date: moment(this.date_range[0]).format("YYYY-MM-DD"),
            end_date: moment(this.date_range[1]).format("YYYY-MM-DD"),
            columns: this.selectedColumns,
            zomato_file: this.zomatoFile,
            swiggy_file: this.swiggyFile,
            menu_file: this.oosFile,
            report_id: this.selectedReport?.id,
          }
        );
        console.log(res);
        if (res.data.status) {
          this.getReports();
          this.key += 1;
          this.fullKey += 1;
        }
        window.location.reload();
        Swal.fire(
          "Successfully Started generating report please be patient",
          "",
          "success"
        );
      } catch (error) {
        console.log(error);
      }
    },
    async getReports() {
      try {
        let res = await axios.get(
          this.base_node_url + BUSSINESS_REPORT_PATH.GET_OSS_REPORT
        );
        console.log(res.data);
        if (res.data.status) {
          this.reports = res.data.data.reports;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
